<div class="search-results-grid-layout px-4 py-3">
  <div class="d-flex justify-content-between mb-3">
    <div class="count-of-results d-flex">
      <div class="mr-3 flex-lg-shrink-0" *ngIf="searchResults != null">{{ searchResults.odata.count }} Results</div>

      <ngx-skeleton-loader *ngIf="searchResults == null" class="mt-1 mr-3" [theme]="{ width: '75px', 'border-radius': '0', height: '23px' }">
      </ngx-skeleton-loader>

      <app-pills-search-results class="d-none d-lg-inline"></app-pills-search-results>
    </div>
    <div class="d-none d-lg-block">
      <label class="mr-2">Sort by</label>
      <common-dropdown
        class="d-inline-block dropdown-container"
        [dropDownItems]="orderByDropDownItems"
        [selectedValue]="selectedOrderBy"
        (itemSelected)="filterResults()"
      ></common-dropdown>
      <button class="btn py-2 px-3 b-grey ml-3 btn-mobile-lg" (click)="shareResults()">
        <i class="icon-share text-red mr-1"></i>
        Share
      </button>
    </div>
    <div class="d-lg-none">
      <button class="btn b-grey" (click)="shareResults()">
        <i class="icon-share text-red"></i>
      </button>
    </div>
  </div>

  <div>
    <app-skeleton-search-results *ngIf="searchResults == null"></app-skeleton-search-results>
    <div class="row" *ngIf="searchResults != null">
      <ng-container *ngFor="let machine of searchResults.value; index as i">
        <div class="col-md-6 col-xxxl-4" *ngIf="i == 5">
          <iframe
            *ngIf="testimonialIframeIdComplete"
            class="the-testimonial"
            id="testimonialto-embed-text--OA-qLoMri0zWh_Yidf7"
            [src]="testimonialIframeIdComplete"
            frameborder="0"
            scrolling="no"
            width="100%"
          ></iframe>
        </div>
        <div class="col-md-6 col-xxxl-4">
          <!-- Check if the machine is Buy It Now Only -->
          <common-buy-only-machine-card-advanced
            *ngIf="machine.buyItNowOnly; else regularMachineCard"
            [machine]="machine"
            [filteredAttachments]="filteredAttachments"
          ></common-buy-only-machine-card-advanced>
          <ng-template #regularMachineCard>
            <common-machine-card-advanced
              [machine]="machine"
              [filteredAttachments]="filteredAttachments"
              [machineIdsInCart]="machineIdsInCart"
            ></common-machine-card-advanced>
          </ng-template>
        </div>
      </ng-container>
      <div class="col-12">
        <app-no-search-results *ngIf="searchResults.value.length == 0"></app-no-search-results>
      </div>
    </div>

    <div class="d-flex justify-content-center" *ngIf="searchResults?.odata?.count > 12">
      <div>
        <mat-paginator
          color="primary"
          *ngIf="searchResults != null"
          [showFirstLastButtons]="true"
          [length]="searchResults.odata.count"
          [hidePageSize]="true"
          [pageIndex]="pageIndex"
          [pageSize]="28"
          aria-label="Select page"
          (page)="handlePageEvent($event)"
          #paginator
        >
        </mat-paginator>
        <div class="font-weight-bold text-center mt-3">Page {{ pageIndex + 1 }} of {{ getNumberOfPages() }}</div>
      </div>
    </div>
  </div>
</div>
<div class="p-0"></div>

<app-search-results-mobile-toggle class="d-lg-none" route="map"></app-search-results-mobile-toggle>
<ng-container *ngIf="searchResults != null">
  <div class="bb-light my-3"></div>
  <div class="p-4">
    <h3 class="font-weight-bold">Need help?</h3>
    <p class="subhead fs-light">Explore guides, tips and tricks for renting and using the equipment you need.</p>

    <div class="row">
      <div class="col-md-4 col-xxxl-3">
        <a class="card mb-4 cursor-pointer border-0 bg-grey br-0 text-dark-grey" href="tel:(866) 455-8531">
          <div class="row no-gutters">
            <div>
              <img class="card-img br-0" src="https://company.rubbl.com/pubweb/marketplace/images/landing-pages/rent-a-machine/support.jpg" />
            </div>
            <div class="align-self-center d-flex">
              <div class="card-body">
                <div class="d-flex">
                  <h4>(866) 455-8531</h4>
                  <div class="ml-auto">
                    <i class="icon-arrow-right"></i>
                    <i class="icon-arrow-right"></i>
                  </div>
                </div>

                <div class="red-separator mb-2"></div>
                <p class="card-text supporting-text">A rental coordinator is standing by ready to help you find the equipment you are looking for.</p>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div class="col-md-4 col-xxxl-3">
        <a class="card mb-4 cursor-pointer border-0 bg-grey br-0 text-dark-grey" href="https://support.rubbl.com/getting-started-guide-renters">
          <div class="row no-gutters">
            <div>
              <img class="card-img br-0" src="https://company.rubbl.com/pubweb/marketplace/images/backgrounds/shannon-get-started.jpg" />
            </div>
            <div class="align-self-center d-flex">
              <div class="card-body">
                <div class="d-flex">
                  <h4>Get started as a renter</h4>
                  <div class="ml-auto">
                    <i class="icon-arrow-right"></i>
                    <i class="icon-arrow-right"></i>
                  </div>
                </div>
                <div class="red-separator mb-2"></div>
                <p class="card-text supporting-text">Everything you need to know about renting your first machine on Rubbl.</p>
              </div>
            </div>
          </div>
        </a>
      </div>
      <!-- <div class="col-md-4 col-xxxl-3">
        <a class="card mb-4 cursor-pointer border-0 bg-grey br-0 text-dark-grey" href="https://support.rubbl.com/insurance-protection">
          <div class="row no-gutters">
            <div>
              <img class="card-img br-0" src="https://company.rubbl.com/pubweb/marketplace/images/backgrounds/shannon-back-turned.jpg" />
            </div>
            <div class="align-self-center d-flex">
              <div class="card-body">
                <div class="d-flex">
                  <h4>Insurance Requirements</h4>
                  <div class="ml-auto">
                    <i class="icon-arrow-right"></i>
                    <i class="icon-arrow-right"></i>
                  </div>
                </div>
                <div class="red-separator mb-2"></div>
                <p class="card-text supporting-text">
                  Rubbl supplies damage insurance on your behalf. You will be required to show proof of commercial liability insurance.
                </p>
              </div>
            </div>
          </div>
        </a>
      </div> -->
    </div>
  </div>
  <common-search-results-nearby-locations></common-search-results-nearby-locations>
  <div class="container px-5">
    <common-category-faqs [facets]="searchResults.search.facets"></common-category-faqs>
  </div>
  <div class="p-4 bg-light-grey bt-light mt-3">
    <h3 class="font-weight-bold">Renting on Rubbl</h3>
    <div class="row">
      <ng-container *ngFor="let rentingInfoCard of rentingInfoCards">
        <div class="col-md-6">
          <common-marketing-card [marketingCard]="rentingInfoCard" [flexRow]="true"></common-marketing-card>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="container">
    <div class="mb-5"></div>
    <h2 class="text-center">Testimonials & Reviews</h2>
    <iframe
      id="testimonialto-carousel-rubbl-homepage-tag-all-light"
      src="https://embed-v2.testimonial.to/carousel/all/rubbl-homepage?theme=light&autoplay=off&showmore=off&one-row=on&same-height=off&tag=all&arrowColor=9BA9B4&hideDate=on"
      frameborder="0"
      scrolling="no"
      width="100%"
    ></iframe>
  </div>
  <common-footer></common-footer>
</ng-container>
